export const registerServiceWorker = () => {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('Service worker registered:', registration.scope);
        // A device that registered an older worker won't notice this one
        // until its next periodic check — ask it to look now.
        registration.update().catch(() => {});
      })
      .catch((error) => {
        console.warn('Service worker registration failed:', error);
      });

    // The page already on screen was built against whatever worker was
    // controlling it when it loaded. Once a newer worker takes over,
    // reload once so stale UI (e.g. an old hero) doesn't linger.
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
};
